import { experimental_extendTheme as extendTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
    interface BreakpointOverrides {
        xs: true;
        sm: true;
        md: true;
        lg: true;
        xl: false;
    }
}

export const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          light: '#FFFFFF',
          main: '#4c64e8',
          dark: '#4c64e8'
        },
        secondary: {
          light: '#f2f2f2',
          main: '#f2f2f2',
          dark: '#f2f2f2',
          contrastText: '#828282'
        },
        text: {
          primary: 'rgba(0,0,0,0.60)',
          secondary: 'rgba(0,0,0,0.87)'
        },
        background: {
          default: '#FFFFFF',
          paper: '#FFFFFF'
        },
        warning: {
          50: '#FFF9EB',
          100: '#FFF3C1',
          200: '#FFECA1',
          300: '#FFDC48',
          400: '#F4C000',
          500: '#DEA500',
          600: '#D18E00',
          700: '#AB6800',
          800: '#8C5800',
          900: '#5A3600',
          light: '#FFDC48',
          main: '#DEA500',
          dark: '#AB6800'
        },
        success: {
          50: '#E9FBF0',
          100: '#C6F6D9',
          200: '#9AEFBC',
          300: '#6AE79C',
          400: '#3EE07F',
          500: '#21CC66',
          600: '#1DB45A',
          700: '#1AA251',
          800: '#178D46',
          900: '#0F5C2E',
          light: '#6AE79C',
          main: '#1AA251',
          dark: '#1AA251'
        },
        error: {
          50: '#FFF0F1',
          100: '#FFDBDE',
          200: '#FFBDC2',
          300: '#FF99A2',
          400: '#FF7A86',
          500: '#FF505F',
          600: '#EB0014',
          700: '#C70011',
          800: '#94000D',
          900: '#570007',
          light: '#FF99A2',
          main: '#EB0014',
          dark: '#C70011'
        },
        info: {
          50: '#F0F7FF',
          100: '#C2E0FF',
          200: '#99CCF3',
          300: '#66B2FF',
          400: '#3399FF',
          500: '#007FFF',
          600: '#0072E5',
          700: '#0059B2',
          800: '#004C99',
          900: '#003A75',
          light: '#66B2FF',
          main: '#007FFF',
          dark: '#0059B2'
        }
      }
    }
  },
  components: {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          marginBottom: '-4px'
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: '-2px',
          marginBottom: '-19px',
          height: '21px'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        disableInteractive: true
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F2F2F2'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          padding: '12px 16px'
        },
        body: {
          padding: '10px 16px'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        filledWarning: {
          color: '#fff'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '8px 24px 24px'
        }
      }
    }
  },
  breakpoints: {
    values: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    }
  }
})
